import React from 'react';
import { useNavigate } from 'react-router-dom';

const HeadSub = ({ title, onBack, iconClose, rightArea }) => {
    const navigate = useNavigate();

    return (
        <div className="header header-sub">
            <div className='left' onClick={onBack || (() => navigate(-1))}>
                <button>
                    <span className='blind'>뒤로가기</span>
                </button>
                <h3>{title}</h3>
            </div>
            {rightArea && <div className='right'>{rightArea}</div>}
        </div>
    );
};

export default HeadSub;